import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

import Loader from "../../../components/loader";
import Comments from "../../../components/Comments";
import api from "../../../services/api";
import SelectUser from "../../../components/selectUser";

export default ({ invoice, setInvoice }) => {
  const [cashout, setCashout] = useState(null);
  const user = useSelector((state) => state.Auth.user);

  const fetchCashout = async () => {
    const { data } = await api.post(`/cashout/search`, {
      search: "",
      query: {},
      page: 1,
      pageSize: 50,
      sort: { created_at: -1 },
      projectId: invoice.projectId,
    });
    setCashout(data?.[0] || {});
  };

  useEffect(() => {
    fetchCashout();
  }, [invoice]);

  if (!invoice || !cashout) return <Loader />;

  const handleAddCashoutLead = async (selected) => {
    try {
      const { data } = await api.put(`/cashout/${cashout._id}`, { leadId: selected?._id, leadName: selected?.name });
      setCashout(data);
      toast.success("Lead updated!");
    } catch (err) {
      toast.error("Failed to update lead");
    }
  };

  const handleRemoveCashoutLead = async () => {
    try {
      const { data } = await api.put(`/cashout/${cashout._id}`, { leadId: null, leadName: null });
      setCashout(data);
      toast.success("Lead removed!");
    } catch (err) {
      toast.error("Failed to remove lead");
    }
  };

  return (
    <div className="flex flex-col gap-4 p-2">
      <div className="flex-1 flex flex-col gap-4">
        <div className="max-w-lg flex w-full items-center gap-x-4">
          <div className="my-4">
            <label className="block text-sm font-medium text-gray-700">Next action Date</label>
            <input
              type="date"
              value={invoice.nextActionDate ? invoice.nextActionDate.split("T")[0] : ""}
              onChange={async (e) => {
                const { data } = await api.put(`/invoice/${invoice._id}`, { nextActionDate: e.target.value });
                setInvoice(data);
                toast.success("Collection date updated!");
              }}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div className="my-4">
            <label className="block text-sm font-medium text-gray-700">Collection Status</label>
            <select
              value={invoice.collection_status}
              onChange={async (e) => {
                const { data } = await api.put(`/invoice/${invoice._id}`, { collection_status: e.target.value });
                setInvoice(data);
                toast.success("Collection status updated!");
              }}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
              <option value=""></option>
              <option value="In progress">In progress</option>
              <option value="Late payment in progress">Late payment in progress</option>
              <option value="First reminder">First reminder</option>
              <option value="Second reminder + Call">Second reminder + Call</option>
              <option value="Third reminder">Third reminder</option>
              <option value="Mise en demeure to send">Mise en demeure to send</option>
              <option value="Mise en demeure sent">Mise en demeure sent</option>
              <option value="Mise en demeure received">Mise en demeure received</option>
              <option value="Fourth reminder">Fourth reminder</option>
              <option value="Injonction de payer to start">Injonction de payer to start</option>
              <option value="Injonction de payer sent">Injonction de payer sent</option>
            </select>
          </div>
          <div className="my-4">
            <label className="block text-sm font-medium text-gray-700">Lead Cashout</label>
            {user?.role === "admin" ? (
              <SelectUser
                value={cashout.leadName ? { _id: cashout.leadId, name: cashout.leadName } : null}
                userRoles={["admin"]}
                placeholder="Select lead"
                onChange={(selected) => {
                  if (!selected) {
                    handleRemoveCashoutLead();
                    return;
                  }
                  handleAddCashoutLead(selected);
                }}
                buttonClassName="border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
              />
            ) : (
              <div className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm px-3 py-2">
                {invoice.leadName || <span className="text-gray-400">No lead assigned</span>}
              </div>
            )}
          </div>
        </div>

        <Comments
          value={invoice.comments}
          onAdd={async (text) => {
            const comments = [
              ...invoice.comments,
              {
                text,
                user_id: user._id,
                user_name: user.name,
                user_avatar: user.avatar,
              },
            ];
            const { data } = await api.put(`/invoice/${invoice._id}`, { comments });
            setInvoice(data);
            toast.success("Comment added!");
          }}
          onDelete={async (comment_id) => {
            const comments = invoice.comments.filter((c) => c._id !== comment_id);
            const { data } = await api.put(`/invoice/${invoice._id}`, { comments });
            setInvoice(data);
            toast.success("Comment deleted!");
          }}
        />
      </div>
    </div>
  );
};
